import React, { useState } from "react";
import { Container, Row } from "reactstrap";
import { useLocation } from "react-router-dom"; // Import useLocation
import { ReactComponent as DashboardIcon } from "../../assets/img/category.svg";
import { ReactComponent as SettingIcon } from "../../assets/img/setVector.svg";
import { ReactComponent as TransactionIcon } from "../../assets/img/TransactionIconVector.svg";
import { ReactComponent as SupportIcon } from "../../assets/img/supVector.svg";
import AuthService from "services/auth.service";
function MobileFooter() {
  const location = useLocation(); // Get the current location

  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  // Function to check if the route is active
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active-mob" : "";
  };

  const logOut = () => {
    AuthService.logout();

    setShowAdminBoard(false);
    setCurrentUser(undefined);
  };

  return (
    <footer>
      <Container>
        <Row>
          <div className="navbar-mob">
            <a
              href="/user/dashboard"
              className={`nav-item-mob ${activeRoute("/user/dashboard")}`}
            >
              <DashboardIcon />
            </a>
            <a
              href="/user/tables"
              className={`nav-item-mob ${activeRoute("/user/tables")}`}
            >
              <TransactionIcon />
            </a>
            <a
              href="/user/notifications"
              className={`nav-item-mob ${activeRoute("/user/notifications")}`}
            >
              <SettingIcon />
            </a>
            <a
              href="/user/user-page"
              className={`nav-item-mob ${activeRoute("/user/user-page")}`}
            >
              <SupportIcon />
            </a>
            <a
              href="/"
              onClick={logOut}
              className={"fa-solid fa-arrow-right-from-bracket nav-item-mob"}
              style={{ width: "24px", height: "24px", color: "red" }}
            >
              
            </a>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default MobileFooter;
